<template>
    <div>
        <transition name="collapsible">
            <div v-if="!isCollapsed">
                <EventEntryDetails :event="event" class="event-details card p-4"/>
            </div>
        </transition>
        <div class="position-relative">
            <base-button v-if="!expandedByDefault"
                         :class="{'is-collapsed': isCollapsed}" type="primary" class="collapser" outline
                         @click="isCollapsed = !isCollapsed">
                <template v-if="isCollapsed">
                    {{ $t('iFrame.showMoreDetails') }}
                </template>
                <template v-else>
                    {{ $t('iFrame.showLessDetails') }}
                </template>
                <font-awesome-icon class="ml-3 chevron" icon="chevron-up"></font-awesome-icon>
            </base-button>
        </div>
    </div>
</template>

<script>
import EventEntryDetails from "@/components/pages/eventIFrame/EventEntry/EventEntryDetails/EventEntryDetails";

export default {
    name: "EventEntryDetailsCollapser",
    components: {EventEntryDetails},
    props: {
        event: {
            type: Object,
            required: true
        },
        expandedByDefault: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isCollapsed: !this.expandedByDefault
        }
    },

}
</script>

<style lang="scss" scoped>
$button-height: 1.875rem;

.event-details {
    margin: 0 map-get($spacers, 3);
    padding-bottom: map-get($spacers, 5) !important;
    border-top-right-radius: 0;
    border-top-left-radius: 0;
}

.collapser {
    position: absolute;
    left: 50%; /* Position X halfway in */
    transform: translate(-50%, 0); /* Move it halfway back(x,y) */
    height: $button-height;
    width: 13.25rem;
    transition: bottom 0.3s;


    &:not(.is-collapsed) {
        bottom: 0;
        border-bottom: none;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
    }


    &.is-collapsed {
        bottom: -$button-height;
        border-top: none;
        border-top-left-radius: 0;
        border-top-right-radius: 0;
    }


    .chevron {
        transition: transform 0.3s;
    }

    &.is-collapsed {
        .chevron {
            transform: rotate(180deg);
        }
    }

}

.collapsible-enter-active, .collapsible-leave-active {
    transition: max-height 0.5s;
    overflow: hidden;
}

.collapsible-enter, .collapsible-leave-to {
    max-height: 0;
}

.collapsible-enter-to, .collapsible-leave {
    max-height: 700px;
}


</style>
